/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Donor_Goto1Inputs */

const id_profile_donor_goto1 = /** @type {(inputs: Profile_Donor_Goto1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pergi ke`)
};

const ms_profile_donor_goto1 = /** @type {(inputs: Profile_Donor_Goto1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pergi ke`)
};

const da_profile_donor_goto1 = /** @type {(inputs: Profile_Donor_Goto1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gå til`)
};

const de_profile_donor_goto1 = /** @type {(inputs: Profile_Donor_Goto1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gehe zu`)
};

const en_us2_profile_donor_goto1 = /** @type {(inputs: Profile_Donor_Goto1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to`)
};

const es_es2_profile_donor_goto1 = /** @type {(inputs: Profile_Donor_Goto1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir a`)
};

const es_mx2_profile_donor_goto1 = /** @type {(inputs: Profile_Donor_Goto1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir a`)
};

const fil_profile_donor_goto1 = /** @type {(inputs: Profile_Donor_Goto1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pumunta sa`)
};

const fr_profile_donor_goto1 = /** @type {(inputs: Profile_Donor_Goto1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aller sur`)
};

const it_profile_donor_goto1 = /** @type {(inputs: Profile_Donor_Goto1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai a`)
};

const hu_profile_donor_goto1 = /** @type {(inputs: Profile_Donor_Goto1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ugrás`)
};

const nl_profile_donor_goto1 = /** @type {(inputs: Profile_Donor_Goto1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ga naar`)
};

const no_profile_donor_goto1 = /** @type {(inputs: Profile_Donor_Goto1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gå til`)
};

const pl_profile_donor_goto1 = /** @type {(inputs: Profile_Donor_Goto1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przejdź do`)
};

const pt_br2_profile_donor_goto1 = /** @type {(inputs: Profile_Donor_Goto1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vá para`)
};

const pt_profile_donor_goto1 = /** @type {(inputs: Profile_Donor_Goto1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir para`)
};

const ro_profile_donor_goto1 = /** @type {(inputs: Profile_Donor_Goto1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mergi la`)
};

const fi_profile_donor_goto1 = /** @type {(inputs: Profile_Donor_Goto1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siirry`)
};

const sv_profile_donor_goto1 = /** @type {(inputs: Profile_Donor_Goto1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gå till`)
};

const vi_profile_donor_goto1 = /** @type {(inputs: Profile_Donor_Goto1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đi đến`)
};

const tr_profile_donor_goto1 = /** @type {(inputs: Profile_Donor_Goto1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şuraya git`)
};

const cs_profile_donor_goto1 = /** @type {(inputs: Profile_Donor_Goto1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přejít na`)
};

const bg_profile_donor_goto1 = /** @type {(inputs: Profile_Donor_Goto1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отидете на`)
};

const ru_profile_donor_goto1 = /** @type {(inputs: Profile_Donor_Goto1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перейти по`)
};

const uk_profile_donor_goto1 = /** @type {(inputs: Profile_Donor_Goto1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перейти за`)
};

const ar_profile_donor_goto1 = /** @type {(inputs: Profile_Donor_Goto1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اذهب إلى`)
};

const hi_profile_donor_goto1 = /** @type {(inputs: Profile_Donor_Goto1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यहाँ जाएँ`)
};

const th_profile_donor_goto1 = /** @type {(inputs: Profile_Donor_Goto1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไปที่`)
};

const ja_profile_donor_goto1 = /** @type {(inputs: Profile_Donor_Goto1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`こちらへ`)
};

const zh_cn2_profile_donor_goto1 = /** @type {(inputs: Profile_Donor_Goto1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前往`)
};

const zh_hant1_profile_donor_goto1 = /** @type {(inputs: Profile_Donor_Goto1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前往`)
};

const ko_profile_donor_goto1 = /** @type {(inputs: Profile_Donor_Goto1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이동`)
};

/**
* | output |
* | --- |
* | "Go to" |
*
* @param {Profile_Donor_Goto1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_donor_goto1 = /** @type {((inputs?: Profile_Donor_Goto1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Donor_Goto1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_donor_goto1(inputs)
	if (locale === "ms") return ms_profile_donor_goto1(inputs)
	if (locale === "da") return da_profile_donor_goto1(inputs)
	if (locale === "de") return de_profile_donor_goto1(inputs)
	if (locale === "en-US") return en_us2_profile_donor_goto1(inputs)
	if (locale === "es-ES") return es_es2_profile_donor_goto1(inputs)
	if (locale === "es-MX") return es_mx2_profile_donor_goto1(inputs)
	if (locale === "fil") return fil_profile_donor_goto1(inputs)
	if (locale === "fr") return fr_profile_donor_goto1(inputs)
	if (locale === "it") return it_profile_donor_goto1(inputs)
	if (locale === "hu") return hu_profile_donor_goto1(inputs)
	if (locale === "nl") return nl_profile_donor_goto1(inputs)
	if (locale === "no") return no_profile_donor_goto1(inputs)
	if (locale === "pl") return pl_profile_donor_goto1(inputs)
	if (locale === "pt-BR") return pt_br2_profile_donor_goto1(inputs)
	if (locale === "pt") return pt_profile_donor_goto1(inputs)
	if (locale === "ro") return ro_profile_donor_goto1(inputs)
	if (locale === "fi") return fi_profile_donor_goto1(inputs)
	if (locale === "sv") return sv_profile_donor_goto1(inputs)
	if (locale === "vi") return vi_profile_donor_goto1(inputs)
	if (locale === "tr") return tr_profile_donor_goto1(inputs)
	if (locale === "cs") return cs_profile_donor_goto1(inputs)
	if (locale === "bg") return bg_profile_donor_goto1(inputs)
	if (locale === "ru") return ru_profile_donor_goto1(inputs)
	if (locale === "uk") return uk_profile_donor_goto1(inputs)
	if (locale === "ar") return ar_profile_donor_goto1(inputs)
	if (locale === "hi") return hi_profile_donor_goto1(inputs)
	if (locale === "th") return th_profile_donor_goto1(inputs)
	if (locale === "ja") return ja_profile_donor_goto1(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_donor_goto1(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_donor_goto1(inputs)
	return ko_profile_donor_goto1(inputs)
});
export { profile_donor_goto1 as "profile.donor.goTo" }